export { default } from './InstaBlock';
